export type DocumentColorScheme = 'light' | 'dark'

export interface DocumentColorSchemeRoot {
  classList: Pick<DOMTokenList, 'add' | 'remove'>
  setAttribute(name: string, value: string): void
  style: { colorScheme: string }
}

/**
 * Write the document theme hooks that `global.css` tokens and Tailwind's
 * `dark:` variant key off. ThemeProvider, Identity Admin, and the
 * dashboard sandbox all go through this so `class` / `data-theme` /
 * `data-joy-color-scheme` / `color-scheme` cannot drift.
 */
export function applyDocumentColorScheme(
  scheme: DocumentColorScheme,
  root: DocumentColorSchemeRoot = document.documentElement
): void {
  root.classList.remove('light', 'dark')
  root.classList.add(scheme)
  root.setAttribute('data-theme', scheme)
  root.setAttribute('data-joy-color-scheme', scheme)
  root.style.colorScheme = scheme
}
